const subCmdsJA = {
  server: {
    description: 'Open solv Dashboard',
  },
  start: {
    description: 'Start Solana Validator',
  },
  stop: {
    description: 'Stop Solana Validator',
  },
  status: {
    description: 'Show Solana Validator Status',
  },
  restart: {
    description: 'Restart Solana Validator',
  },
  update: {
    description: 'Update Solana Validator Version',
  },
  get: {
    description: 'Get Solana Validator Info',
  },
  log: {
    description: 'Tail Solana Validator Log',
  },
  catchup: {
    description: 'Catchup Solana Validator',
  },
  monitor: {
    description: 'Monitor Solana Validator',
  },
  config: {
    description: 'Show Solana Validator Config',
  },
  install: {
    description: 'Install/Update Solana Version',
  },
  stake: {
    description: 'Solana Delegate Stake',
  },
  unstake: {
    description: 'UnStake',
  },
  check: {
    description: 'Check Solana Validator',
  },
  scp: {
    description: 'Download/Upload Solana Validator Keypairs',
  },
  cron: {
    description: 'Run Schedule Tasks',
  },
  setup: {
    description: 'Setup Solana Validator',
  },
  epoch: {
    description: 'Show Current Epoch',
  },
  slot: {
    description: 'Show Current Slot',
  },
  solv: {
    description: 'Endroll Solv AA',
  },
}

export default subCmdsJA
